import styled from 'styled-components'

export const CheckoutContainer = styled.section`
    display: flex;
    flex-direction: column;
    width: 500px;
    gap: 8px;
    hr {
        border: 1px solid ${properties => properties.theme.variables.colorGray.secondary};
        border-bottom: 0;
        margin: 6px;
    }
    @media only screen and (min-width: 810px) {
        gap: 12px;
        hr {
            margin: 0.56rem 0;
        }
    }
`

export const CheckoutTitle = styled.h2`
    height: 27px;

    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 27px;

    color: ${properties => properties.theme.variables.colorText};
`

interface ICheckoutRowProperties {
    alignCenter?: boolean
}

export const CheckoutRow = styled.div<ICheckoutRowProperties>`
    display: flex;
    align-items: ${properties => (properties.alignCenter ? 'center' : 'flex-start')};
    justify-content: space-between;
    margin: 0;
`
interface ICheckoutColProperties {
    flexStart?: boolean
}

export const CheckoutCol = styled.div<ICheckoutColProperties>`
    display: flex;
    flex-direction: column;
    align-items: ${properties => (properties.flexStart ? 'flex-start' : 'flex-end')};
`

export const CheckoutLeftItem = styled.strong`
    height: 18px;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: ${properties => properties.theme.variables.colorText};
`

export const CheckoutRightItem = styled.p`
    height: 18px;
    display: flex;
    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.2em;
    white-space: pre-wrap;
    color: ${properties => properties.theme.variables.colorText};

    label {
        white-space: pre;
        color: #7755cc;
        text-decoration: underline;
        line-height: 1.2;
        cursor: pointer;
    }
`

export const CheckoutRightItemLight = styled.p`
    height: 13px;
    margin-top: 0.5rem;
    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 13px;

    color: ${properties => properties.theme.variables.colorText};

    opacity: 0.5;
`

export const CheckoutDivider = styled.div`
    border: 1px solid ${properties => properties.theme.variables.colorGray.primary};
`
export const CheckoutTotalDivider = styled.div`
    border: 1px solid ${properties => properties.theme.variables.colorGray.primary};
    border-bottom: 0;
`

export const CheckoutButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    @media only screen and (max-width: 768px) {
        width: 100%;
    }
    @media only screen and (max-width: 540px) {
        width: 100%;
    }
`

export const CheckoutItemBox = styled.div`
    height: 36px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const FeedbackItem = styled.span`
    position: absolute;
    height: 13px;

    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 13px;
    transform: translateY(-24px);
    color: #f90215;
`
